<template>
  <article :class="{'fshr-resortCard--summer': season===0, 'fshr-resortCard': true}">
    <div class="fshr-resortCard__content">
      <header class="fshr-resortCard__header">
        <a
          :href="trips_link_cleaned"
          v-if="resort.name"
          class="fshr-resortCard__title"
        >
          {{ resort.name }}
        </a>
        <LocationBreadcrumbs
          v-if="resort.location"
          :locations="resort.location"
        />
      </header>
      <ResortFacilities
        v-if="(resort.facilities || []).length && season"
        class="fshr-resortCard__facilities"
        :facilities="resort.facilities"
      />
      <Grid
        v-if="(resort.slopes_rating || resort.slopes_rating) && season"
        class="fshr-resortCard__rating"
      >
        <GridItem
          :xxs="6"
          v-if="resort.slopes_rating"
          class="fshr-resortCard__ratingItem"
        >
          <span class="fshr-resortCard__ratingLabel">{{
            getTranslation("slopesRatingLabel")
          }}</span>
          <StarRating
            class="fshr-resortCard__ratingStars"
            :rating="resort.slopes_rating"
          />
        </GridItem>
        <GridItem
          :xxs="6"
          v-if="resort.total_rating"
          class="fshr-resortCard__ratingItem"
        >
          <span class="fshr-resortCard__ratingLabel">{{
            getTranslation("totalRatingLabel")
          }}</span>
          <StarRating
            class="fshr-resortCard__ratingStars"
            :rating="resort.total_rating"
          />
        </GridItem>
      </Grid>
      <Grid v-if="season">
        <GridItem
          v-if="resort.ski_slopes && (resort.ski_slopes.slopes || []).length"
          :sm="4"
          :xxs="6"
          class="fshr-resortCard__col"
        >
          <div class="fshr-resortCard__label">
            {{ getTranslation("elevatorsAmountLabel") }}:
            <span class="fshr-resortCard__value">
              {{ resort.ski_slopes.total }}
            </span>
          </div>
          <ResortSkiSlopes
            :slopes="resort.ski_slopes.slopes"
            :key="resort.ski_slopes.total"
            class="fshr-resortCard__list"
          />
        </GridItem>
        <GridItem
          v-if="resort.ski_trails && (resort.ski_trails.trails || []).length"
          :sm="4"
          :xxs="6"
          class="fshr-resortCard__col"
        >
          <div class="fshr-resortCard__label">
            {{ getTranslation("trailsLengthLabel") }}:
            <span class="fshr-resortCard__value">
              {{ resort.ski_trails.total }} {{ getTranslation("km") }}
            </span>
          </div>
          <ResortSkiTrails
            :trails="resort.ski_trails.trails"
            :key="resort.ski_trails.total"
            :translations="translations"
            class="fshr-resortCard__list"
          />
        </GridItem>
        <GridItem :sm="4">
          <Grid class="fshr-resortCard__info">
            <GridItem :sm="12" :xxs="6" class="fshr-resortCard__col">
              <div class="fshr-resortCard__label">
                {{ getTranslation("altitudeLabel") }}:
                <span class="fshr-resortCard__value">
                  {{ resort.altitude }}
                </span>
              </div>
            </GridItem>
            <GridItem :sm="12" :xxs="6" class="fshr-resortCard__col">
              <div class="fshr-resortCard__label">
                {{ getTranslation("runningTrailsLengthLabel") }}:
                <span class="fshr-resortCard__value">
                  {{ resort.cross_country_trails }} {{ getTranslation("km") }}
                </span>
              </div>
              <div class="fshr-resortCard__label">
                {{ getTranslation("snowparksAmountLabel") }}:
                <span class="fshr-resortCard__value"
                  >{{ resort.snowparks }}x</span
                >
              </div>
            </GridItem>
          </Grid>
        </GridItem>
        <GridItem
          v-if="resort.distances && (resort.distances || []).length"
          :xxs="12"
        >
          <ul class="fshr-resortCard__defs">
            <li
              v-for="distance in resort.distances"
              :key="distance.id"
              class="fshr-resortCard__def"
            >
              <span class="fshr-resortCard__defLabel"
                >{{ distance.location }}:
              </span>
              <span class="fshr-resortCard__defValue">
                {{ distance.distance }} km
              </span>
            </li>
          </ul>
        </GridItem>
      </Grid>
      <Grid v-if="season === 0">
        <GridItem :sm="12" :xl="4">
          <img :src="resort.image_url" class="fshr-resortCard__image">
        </GridItem>
        <GridItem :sm="12" :xl="8">
          <div v-html="resort.description"></div>
          <a :href="trips_link_description">{{getTranslation("more")}}</a>
        </GridItem>
      </Grid>
    </div>
    <footer class="fshr-resortCard__footer">
      <div v-if="!is_preparing">
        <div class="fshr-resortCard__priceWrapper" v-if="season">
          <div class="fshr-resortCard__skipasBadge">
            <i class="icon-tag fshr-resortCard__skipasBadgeIcon" />
            <span class="fshr-resortCard__skipasBadgeLabel">
              {{ resort.skipas_badge }}
            </span>
          </div>

          <div class="fshr-resortCard__price">
            <div class="fshr-resortCard__priceLabel">
              <span v-if="resort.per_person > 1">{{ resort.per_person }}</span>
              {{ getTranslation("n_dospely", resort.per_person) }}
              {{ getTranslation("priceFromLabel") }}
            </div>
            <div class="fshr-resortCard__priceContent">
              <span class="fshr-resortCard__priceValue">
                {{
                  resort.price.price
                    | formatCurrency(resort.price.currency, false)
                }}
                <span class="fshr-resortCard__priceCurrency">{{
                  resort.price.currency
                }}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="fshr-resortCard__buttons">
          <div class="fshr-resortCard__price" v-if="season === 0">
            <div class="fshr-resortCard__priceLabel">
              <span v-if="resort.per_person > 1">{{ resort.per_person }}</span>
              {{ getTranslation("n_dospely", resort.per_person) }}
              {{ getTranslation("priceFromLabel") }}
            </div>
            <div class="fshr-resortCard__priceContent">
              <span class="fshr-resortCard__priceValue">
                {{
                  resort.price.price
                    | formatCurrency(resort.price.currency, false)
                }}
                <span class="fshr-resortCard__priceCurrency">{{
                  resort.price.currency
                }}</span>
              </span>
            </div>
          </div>
          <Button
            class="fshr-resortCard__btn"
            @onClick="openSkimap()"
            iconLeft="icon-mapa1"
            color="secondary"
            size="md"
            v-if="season"
          >
            {{ getTranslation("mapLabel") }}
          </Button>
          <Button
            class="fshr-resortCard__btn"
            :href="resort.trips_link"
            iconLeft="icon-ubytovani"
            color="primary"
            size="md"
          >
            {{ resort.trips_count }}
            {{ getTranslation("n_found_trips", resort.trips_count) }}
          </Button>
        </div>
      </div>
      <div v-else>
        <div class="fshr-preparingTrip" :class="{'fshr-preparingTripLogged': logged}">
          <i class="fshr-icon fshr-icon--calendar"></i>
          <h3>{{getTranslation("totoStrediskoChystame")}}</h3>
          <form v-if="!logged" class="js-form" data-callbyvalid="runWatchDog" :action="api_url_watchdog" :data-id="resort.id" data-type="stredisko">
            <div class="form-field">
              <input type="email" :placeholder="getTranslation('zadejteEmail')" class="form-control js-watchDogEmail" data-form-required="true">
            </div>
            <button type="submit" class="fshr-button fshr-button--iconed fshr-icon fshr-icon--caretRight fshr-button--moreImportance fshr-button--big fshr-button--fullWidth">{{getTranslation("dejteMiVedet")}}</button>
          </form>
          <form v-else :action="api_url_watchdoglogged">
            <input type="hidden" name="id" :value="resort.id">
            <input type="hidden" name="type" value="stredisko">
            <button type="submit" class="fshr-button fshr-button--iconed fshr-icon fshr-icon--caretRight fshr-button--moreImportance fshr-button--big fshr-button--fullWidth">{{getTranslation("dejteMiVedet")}}</button>
          </form>
        </div>
      </div>
    </footer>
  </article>
</template>

<script>
import LocationBreadcrumbs from "./common/LocationBreadcrumbs.vue";
import StarRating from "./common/StarRating.vue";
import ResortFacilities from "./common/ResortFacilities.vue";
import ResortSkiSlopes from "./common/ResortSkiSlopes.vue";
import ResortSkiTrails from "./common/ResortSkiTrails.vue";
import Button from "./common/Button.vue";
import Grid from "./elements/Grid.vue";
import GridItem from "./elements/GridItem.vue";
import distanceMixin from "../mixins/distanceMixin";
import myHelper from "../helpers/myHelper";
import Popup from "./Popup";

export default {
  name: "resort-card",

  components: {
    Popup,
    LocationBreadcrumbs,
    StarRating,
    ResortFacilities,
    ResortSkiSlopes,
    ResortSkiTrails,
    Button,
    Grid,
    GridItem,
  },

  methods: {
    openSkimap: function () {
      console.log(this.resort.map_link);
      this.$root.$emit("openPopup", "skimap");
      this.$root.$emit("setSkimap", this.resort.map_link);
    },
  },

  computed: {
    is_preparing: function () {
      if(this.resort.hasOwnProperty("preparing")){
        return this.resort.preparing;
      }else{
        return false;
      }
    },
    trips_link_cleaned: function () {
      if(this.resort.trips_link.search('#') !== -1){
        return this.resort.trips_link.split('#')[0];
      }else{
        return this.resort.trips_link;
      }
    },
    trips_link_description: function () {
      return this.trips_link_cleaned + '#popis';
    }
  },
  props: {
    resort: {
      type: Object,
      required: true,
    },
    logged: {
      type: Boolean,
      required: false,
      default: false,
    },
    api_url_watchdoglogged: {
      default: "",
      type: String,
      required: false
    },
    api_url_watchdog: {
      default: "",
      type: String,
      required: false
    },
    season: {
      type: Number,
      required: false,
      default: 1
    },
    translations: {
      default() {
        return {};
      },
    },
  },

  mixins: [distanceMixin, myHelper],
};
</script>

<style lang="less">
  @import './../less/variables';
  @import './../../../../../Content/css/components/component-resort-card';
</style>
